import { DRUG_ITEM, drugTestingApplies, drugTestingDone } from "@/lib/drugTesting";

const slug = (s) => String(s).replace(/[^A-Za-z0-9]+/g, "-").toLowerCase();

export function expectedItems(p) {
  const groups = [];
  (p.drivers || []).forEach((d, i) => {
    if (!d.id) return;
    const who = d.name || `Driver ${i + 1}`;
    groups.push({
      key: `driver-${d.id}`, driverId: d.id, contact: d.emergency_contact, title: who, subtitle: d.cdl_class ? `CDL Class ${d.cdl_class}` : "Driver",
      items: [
        { id: `license_front:${d.id}`, label: "Driver's license – front", dated: false, photo: true },
        { id: `license_back:${d.id}`, label: "Driver's license – back", dated: false, photo: true },
        { id: `cdl:${d.id}`, label: "CDL renewal date", dated: true },
        { id: `medical:${d.id}`, label: "Medical card", dated: true },
      ],
    });
  });
  const vehicles = (p.vehicles || []).map((v) => ({ id: `registration:${slug(v)}`, label: `Vehicle registration – ${v}`, dated: true }));
  if (vehicles.length) groups.push({ key: "vehicles", title: "Vehicles", subtitle: "Registration", items: vehicles });
  const company = [
    { id: "insurance", label: "Insurance certificate", dated: true },
    { id: "usdot_biennial", label: "USDOT biennial update due", dated: true },
    { id: "ucr", label: "UCR registration renewal (annual)", dated: true },
  ];
  if (p.ifta_required) company.push({ id: "ifta", label: "IFTA license renewal (annual)", dated: true });
  if (p.irp_required) company.push({ id: "irp", label: "IRP cab card expiration (annual)", dated: true });
  groups.push({ key: "company", title: "Company", subtitle: "Authority & insurance", items: company });
  return groups;
}

export function docStatus(expires) {
  if (!expires) return "none";
  const today = new Date(new Date().toDateString());
  const days = Math.round((new Date(`${expires}T00:00:00`) - today) / 86400000);
  if (days < 0) return "expired";
  if (days <= 60) return "expiring";
  return "current";
}

export const DOC_STATUS = {
  current: { label: "Current", cls: "bg-[#16A34A] text-white" },
  expiring: { label: "Expiring Soon", cls: "bg-[#FFD600] text-[#0A0A0A]" },
  expired: { label: "Expired", cls: "bg-[#DC2626] text-white" },
  none: { label: "No date", cls: "border border-[#262626] text-muted-foreground" },
};

export const fmtDate = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

export function missingItems(profile, records) {
  const byId = Object.fromEntries((records || []).map((r) => [r.item_id, r]));
  const all = expectedItems(profile).flatMap((g) => g.items.map((it) => ({ ...it, notifyLabel: g.key.startsWith("driver-") ? `${g.title} – ${it.label}` : it.label })));
  const missing = all.filter((it) => (it.dated ? !byId[it.id]?.expires : !byId[it.id]?.file_name));
  if (drugTestingApplies(profile)) {
    all.push(DRUG_ITEM);
    if (!drugTestingDone(profile)) missing.push(DRUG_ITEM);
  }
  return { total: all.length, missing };
}

export function expiryAlerts(profile, records) {
  const byId = Object.fromEntries((records || []).map((r) => [r.item_id, r]));
  const out = [];
  expectedItems(profile).forEach((g) => g.items.forEach((it) => {
    const exp = byId[it.id]?.expires;
    const st = it.dated ? docStatus(exp) : "none";
    if (st === "expiring" || st === "expired") {
      out.push({ id: it.id, status: st, text: `${g.key === "company" || g.key === "vehicles" ? "" : `${g.title}: `}${it.label} ${st === "expired" ? "expired" : "expires"} ${fmtDate(exp)}` });
    }
  }));
  return out;
}
